<template>
  <div>
    <div class="bg">
      <img src="../../assets/loginbg.jpg" alt="" class="bgimg">
      <div class="box ">

        <div class="cont flex">

          <div class="form_box"><img src="../../assets/loginico.png" alt="" class="ico">
            <div class="logo">
              <img src="../../assets/logo.png" alt="" class="logo">
            </div>
            <div class="title">
              <img src="../../assets/logintit.png" alt="">
            </div>
            <div class="form-box">
              <a-form-model
                  ref="ruleForm"
                  :rules="rules"
                  :model="form"
                  @submit="handleSubmit"
                  @submit.native.prevent
              >
                <a-form-model-item ref="username" prop="username">
                  <a-input v-model="form.username" placeholder="请输入用户名" @blur="(e) => {  form.username = e.target.value.trim() }">
                    <a-icon
                        slot="prefix"
                        type="user"
                        style="color: rgba(0, 0, 0, 0.25);font-size:1.5em"
                    />
                  </a-input>
                </a-form-model-item>
                <a-form-model-item ref="password" prop="password">
                  <a-input v-model="form.password" type="password" placeholder="请输入密码"  @blur="(e) => {  form.password = e.target.value.trim() }">
                    <a-icon
                        slot="prefix"
                        type="lock"
                        style="color: rgba(0, 0, 0, 0.25);font-size:1.5em"
                    />
                  </a-input>
                </a-form-model-item>
                <a-form-model-item ref="captcha" prop="captcha" class="flex captcha-item">
                  <a-input v-model="form.captcha" placeholder="请输入验证码" style="width: 247px;">
                    <a-icon
                        slot="prefix"
                        type="compass"
                        style="color: rgba(0, 0, 0, 0.25);font-size:1.5em"
                    />
                  </a-input>
                  <img
                      :src="previewImage"
                      alt=""
                      id="imaged"
                      class="captcha"
                      @click="getCaptcha"
                      style="width: 167px;"
                  />
                </a-form-model-item>
                <a-button type="primary" html-type="submit" style="width: 100%;height:50px;background-color: #3a5a97">
                  登录
                </a-button>
              </a-form-model>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import md5 from 'js-md5';
import API from "./api";
export default {
  name: "index",
  data() {
    return {
      isClick:true,
      previewImage: "",
      form: {
        // username: "admin",
        // password: "123456",
        username: "",
        password: "",
        captcha: "",
      },

      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "change" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
        ],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    generatorList(data) {
      let dataList=data
      for (let i = 0; i < dataList.length; i++) {
        if(dataList[i].children){
          for (let j = 0; j < dataList[i].children.length; j++) {
            if(dataList[i].children[j].children){
              for( let s=0 ;s<dataList[i].children[j].children.length; s++){
                dataList[i].children.push(dataList[i].children[j].children[s])
              }
              delete dataList[i].children[j].children;

            }
          }
        }
      }
      return dataList
    },
    handleSubmit(e) {
      let that=this
      if(that.isClick) {
        that.isClick = false;
        //定时器
        setTimeout(function() {
          that.isClick = true;
        }, 1000);//一秒内不能重复点击
        //事件
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            const Base64 =require('js-base64').Base64
            let formData=JSON.parse(JSON.stringify(this.form))
            formData.password=Base64.encode(formData.password)
            let time=(new Date()).getTime()
            formData.token=md5(`as1#g19dfs2.1sjfk*9sad6fD8d6#aa324vmL6*H9sadfKxfBW.pas${time}`).toUpperCase()
            formData.tiemstamp=time
            API.login.LOGIN(formData).then((res) => {
              if(res.data.code==200){
                window.sessionStorage.setItem( "homeData", JSON.stringify(res.data.data)  );
                window.sessionStorage.setItem("signature", res.data.data.signature);
                API.login.GET_MENU().then((res) => {
                  if( res.data.code==1) {
                    window.sessionStorage.setItem("navData",JSON.stringify(res.data.data));
                    let generatorList= this.generatorList(res.data.data)
                    let menus=[]
                    generatorList.map((item,index)=>{
                      let menusa={}
                      menusa.title=item.meta.title
                      menusa.icon=item.meta.icon
                      menusa.name=item.name
                      menusa.status=item.meta.status
                      if(item.children){
                        menusa.children=[]
                        item.children.map((items,indexs)=>{
                          let childrens={}
                          childrens.ptit=item.meta.title
                          childrens.title=items.meta.title
                          childrens.name=items.name
                          childrens.status=items.meta.status
                          childrens.meta=items.meta
                          childrens.btnpermissions=items.meta.brnpermissions
                          menusa.children.push(childrens)

                        })
                      }
                      menus.push(menusa)
                    })
                    res.data.data=menus
                    window.sessionStorage.setItem(  "nav",  JSON.stringify(res.data.data)  );
                    window.sessionStorage.setItem("userName", this.form.username);
                    window.localStorage.setItem('openKeys',"Home")
                    window.sessionStorage.setItem("reAddRoutes", 2);
                    this.$nextTick(() => {
                      this.$router.push({ path: "/home" });
                    });
                  }

                });}else{this.getCaptcha() ;this.form.captcha=""}
            });
          } else {
            return false;
          }
        });

      }

    },
    getCaptcha() {
      Promise.resolve(
          this.$axios.get("admin/common/verify", {
                params: {
                  time: Math.random() * 10,
                  height: 32,
                  width: 150,
                  font_size: 18
                },
                responseType: "arraybuffer",
              }
          )
      ).then(res => {
        return 'data:image/png;base64,' + btoa(
            new Uint8Array(res.data)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
        );
      }).then(data => {
        this.previewImage = data //图片地址 <img src='data' />
      })
    },
  },

  mounted() {
    this.getCaptcha();
  },
};
</script>

<style scoped>
/*.form-box {*/
/*  margin-top: 15%;*/
/*  width: 450px;*/
/*  margin-left: calc(50% - 225px);*/
/*}*/
input{text-align: left!important;}
.bg >>> .ant-input{text-align: left!important;}
.bg {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.bg .ico {
  display: inline-block;
  width: auto;
  margin: 25px auto
}

.bg .logo {
  display: block;
  width: 174px;
  margin: 0 auto;

}

.bg .bgimg {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.box {
  text-align: center;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, .6);
  position: relative;
  z-index: 9;
  width: 41.04%
}

.title {
  margin-bottom: 25px
}

.title p {
  position: relative;
  height: 1px;
  background-color: #000;
  text-align: center
}

.title span {
  position: absolute;
  left: 50%;
  top: -10px;
  background-color: rgba(255, 255, 255, .8);
  padding: 0 8px;
  margin-left: -75px;
}

.bg img {
  width: 100%;
}

.form_box >>> .captcha {
  width: 35%;
  display: block;
  float: right;
  height: 50px;border-radius: 5px;
}

.form_box >>> .captchainput {
  width: 63%;
  float: left
}

.cont {
  border-radius: 12px;
  text-align: center;
  background: rgba(255, 255, 255, .6);
  padding-bottom: 40px;
}

.bg .logo img {
  margin: 0 auto;
  display: block;
  margin-bottom: 10px;
  /* margin-top: 20px; */
}

.btn {
  width: 100%;
  /* margin-left: calc(50% - 75px); */
  border-radius: 6px;
  margin-bottom: 45px
}

.form_item {
  margin-bottom: 30px
}

.form_box {
  max-width: 80%;
  margin: 0 auto;
}

.form_box >>> .el-form-item {
  margin-bottom: 25px !important;
}
.captcha{cursor: pointer}
body{height: 100vh!important;overflow: hidden!important;}
.has-error .ant-form-explain, .has-error .ant-form-split{text-align: left!important;}
.form_box >>> .ant-form-explain{text-align: left}
.bg >>> .ant-form-item-control-wrapper{width: 100%!important;}
.bg >>> .ant-form-item-control-wrapper .ant-input{height: 50px;padding-left: 40px;}
.captcha-item >>> .ant-form-item-children{display: flex;align-items: center;justify-content: space-between;}
</style>
